module.exports = __webpack_public_path__ + "1424f5363acb466bbda94731d393afe1.MP3";